const o = {
  id: "MinnesotaGopher5",
  logo: !0,
  name: "Gopher 5",
  style: {
    colorPrimary: "#fc680b"
  }
};
export {
  o as default
};
